module.exports = __webpack_public_path__ + "img/41.a7a7a384.jpg";